export default {
  insentPublisherLoginToken: 'insent-publisher-login-token',
  insentCurrentProject: 'insent-current-project',
  insentNetworkStatus: 'insent-network-status',
  inboxSelectedFilter: 'insent-inbox-selected-filter',
  sectionMessage: {
    appIntegration: 'show-integration/app-message',
  },
  teamsOnlyToken: 'teams-only-token',
};
